import React from 'react'
import AccountsBudgets from 'src/app/AccountsBudgets/AccountsBudgets'
import { SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { accountsBudgetsRouteProps } from 'src/navigation/routeProps'

const AccountsBudgetsAppRoute: AppRoute = {
  routeProps: accountsBudgetsRouteProps,
  component: <AccountsBudgets />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default AccountsBudgetsAppRoute
